import React from 'react'
import Card from './Card';
import RP1 from "../../Images/RA-1n.jpg"
import RP2 from "../../Images/RA-2n.jpg"
import RP3 from "../../Images/RA-3n.gif"
import RP4 from "../../Images/RA-4n.jpg"
import RP5 from "../../Images/RA-5.jpeg"
import RP6 from "../../Images/RA-6.jpeg"

const createElements = () => {
    const elements = [];
    const imageRecentPublication = [RP1, RP2, RP3, RP4, RP5, RP6];
    const TitleRecentPublication = ['Insight into the Structure and Dynamics of Ethanol-Water Binary Mixture Confined in Nanochannel by Mica and Graphene', 'Effects of interfaces on structure and dynamics of water droplets on a graphene surface: A molecular dynamics study', 'Is Ice Nucleation by Organic Crystals Nonclassical? An Assessment of the Monolayer Hypothesis of Ice Nucleation', 'Computationally Efficient Approach for the Identification of Ice-Binding Surfaces and How They Bind Ice', 'Study of Ice Nucleation on Silver Iodide Surface with Defects', 'Ice Adhesion Mechanism on Lubricant-Impregnated Surfaces using Molecular Dynamics Simulations'];
    const TitleLink = ['https://doi.org/10.1021/acs.jpcb.2c04998', 'https://doi.org/10.1063/5.0046817', 'https://pubs.acs.org/doi/10.1021/jacs.0c12012', 'https://doi.org/10.1063/5.0021631', 'https://doi.org/10.1080/00268976.2019.1657599', 'https://doi.org/10.1080/08927022.2018.1513649']
    const authorsRecentPublication = ['Atanu K. Metya', 'Manish Maurya, Atanu K. Metya, Jayant K. Singh, and Shinji Saito', 'Atanu K. Metya and Valeria Molinero', 'Pavithra M. Naullage, Atanu K. Metya, and Valeria Molinero', 'Prerna, Rohit Goswami, Atanu K. Metya, S. V. Shevkunov, and Jayant K. Singh', 'Atanu K. Metya and Jayant K Singh'];
    const paper = ['J. Phys. Chem. B 2022, 126, 7385-7392', 'J. Chem. Phys. (2021), 154,164704', 'J. Am. Chem. Soc. (2021), 143, 12, 4607-4624', 'J. Chem. Phys. (2020), 153, 174106', 'Mol. Phys. (2019), 117, 3651-3663', 'Mol. Simul. (2019), 45,394–402']

    for (var i=0;i<6;i++){
        elements.push(<Card key = {i} image = {imageRecentPublication[i]} title = {TitleRecentPublication[i]} titleLink = {TitleLink[i]} author = {authorsRecentPublication[i]} paper = {paper[i]}/>)
    }
    return elements
}

const RecentPublications = () => {
  return (
    <div className="album py-5 bg-light-gray">
    <div className="container">
      <h2 className='heading'> Recent Publications </h2>
      <hr/>
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        {createElements()}
      </div>
    </div>
  </div>
  )
}

export default RecentPublications